import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { passwordMatchValidator, PasswordValidator } from 'src/app/shared/custom-validators';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from '../../services/main_local.service';

@Component({
  selector: 'app-changePassword',
  templateUrl: './changePassword.component.html',
  styleUrls: ['./changePassword.component.scss']
})
export class ChangePasswordComponent implements OnInit {
 changePasswordForm!: FormGroup;
 hide = true;
 confirmhide = true;
 current_hide = true;
 currentPassword:any;
 newPassword:any;
 confirmPassword:any;
 authToken: any = null; 
  constructor( 
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private httpService : HttpService,
    private snackBar:MatSnackBar,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private dialog : MatDialog, 
    ) { 
    
  }
  ngOnInit(): void {
    this.authToken = localStorage.getItem("mdr-token-auth");
    this.changePasswordForm = this.fb.group(
        {
        currentPassword: ['', [Validators.required, PasswordValidator]],
        newPassword: ['', [Validators.required, PasswordValidator]],
        confirmPassword: ['', [Validators.required, PasswordValidator, passwordMatchValidator('newPassword')]],
       },
      );
   
  }

  keyPressPassword(event:any){
    let inp = String.fromCharCode(event.keyCode);
  
    if (/[><,:;^'"]/.test(inp)) {
      event.preventDefault();
      return false;
    } else {
      
      return true;
    }
  } 


  onConfirm(){
    this.spinner.show();
    const body: any = {
      "oldPassword": this.changePasswordForm.get('currentPassword')?.value,
      "newPassword": this.changePasswordForm.get('newPassword')?.value
    }
    this.httpService.postRequestCall('auth/changePassword', body, this.authToken, {}).subscribe({
      next: (value)=>{
        let val:any = value;
        this.spinner.hide();
        this.snackBar.open((val?.message), '', {
         horizontalPosition: 'center',
         verticalPosition: 'bottom',
         duration: 3 * 1000,
      });
      this.dialogRef.close({ data: 'confirmed' }) 
      },
      error:(err)=>{
        this.errorStatusFun(err);
      }
    })
  }

  onCancel(){
    this.dialogRef.close({ data: 'cancelled' })
  }

  errorStatusFun(error:any){
    this.spinner.hide();
    this.snackBar.open((error.error.message), '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3 * 1000,
    });
  }

}
